import React, { useEffect } from "react";
import { usePohrebka2 } from "../../context/Pohrebka2Context";

const cardStyle = {
  background: "#fff",
  border: "1px solid #e5e7eb",
  borderRadius: 24,
  padding: 24,
  boxShadow: "0 10px 30px rgba(15,23,42,0.06)",
};

const gridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
  gap: 16,
};

const labelStyle = {
  display: "block",
  fontSize: 14,
  fontWeight: 700,
  color: "#111827",
  marginBottom: 8,
};

const inputStyle = {
  width: "100%",
  padding: "12px 14px",
  borderRadius: 14,
  border: "1px solid #d1d5db",
  fontSize: 15,
  background: "#fff",
  outline: "none",
  boxSizing: "border-box",
};

export default function Pohrebka2VypravitelForm() {
  const { order, patchSection, currentOrderId } = usePohrebka2();

  useEffect(() => {
    const handler = (e) => {
      const full = String(e?.detail?.objednavatel || "").trim();
      if (!full) return;

      const parts = full.split(/\s+/).filter(Boolean);
      const jmeno = parts.shift() || "";
      const prijmeni = parts.join(" ");

      patchSection("vypravitel", {
        ...(jmeno ? { jmeno } : {}),
        ...(prijmeni ? { prijmeni } : {}),
      });
    };

    window.addEventListener("pohrebka2-calendar-create-date", handler);
    return () => window.removeEventListener("pohrebka2-calendar-create-date", handler);
  }, [patchSection]);
  const v = order?.vypravitel || {};

  const setField = (name, value) => {
    const val = String(value || "");

    if (name === "jmeno" || name === "prijmeni") {
      const current = order?.vypravitel || {};
      const nextJmeno = name === "jmeno" ? val : String(current?.jmeno || "").trim();
      const nextPrijmeni = name === "prijmeni" ? val : String(current?.prijmeni || "").trim();
      const fullName = [nextJmeno, nextPrijmeni].filter(Boolean).join(" ").trim();

      patchSection("vypravitel", { [name]: val });
      if (fullName) {
        patchSection("zaklad", { vypravitel: fullName });
      }
      return;
    }

    patchSection("vypravitel", { [name]: val });
  };

  return (
    <div style={cardStyle}>
      <div style={{ display: "flex", justifyContent: "space-between", gap: 16, flexWrap: "wrap", marginBottom: 20 }}>
        <div>
          <div style={{ fontSize: 34, fontWeight: 900, color: "#111827", lineHeight: 1.05 }}>Vypravitel</div>
          <div style={{ marginTop: 8, color: "#6b7280", fontSize: 16 }}>
            Kontaktní a adresní údaje vypravitele.
          </div>
        </div>
        <div style={{ textAlign: "right" }}>
          <div style={{ fontSize: 14, color: "#6b7280", fontWeight: 700 }}>Aktivní zakázka</div>
          <div style={{ fontSize: 28, fontWeight: 900, color: "#111827" }}>{currentOrderId || "-"}</div>
        </div>
      </div>

      <div style={gridStyle}>
        <div>
          <label style={labelStyle}>Jméno</label>
          <input type="text" value={v.jmeno || ""} onChange={(e) => setField("jmeno", e.target.value)} style={inputStyle} />
        </div>

        <div>
          <label style={labelStyle}>Příjmení</label>
          <input type="text" value={v.prijmeni || ""} onChange={(e) => setField("prijmeni", e.target.value)} style={inputStyle} />
        </div>

          <div>
            <label style={labelStyle}>Datum narození</label>
            <input type="date" value={v.datumNarozeni || ""} onChange={(e) => setField("datumNarozeni", e.target.value)} style={inputStyle} />
          </div>

        <div>
          <label style={labelStyle}>Telefon</label>
          <input type="text" value={v.telefon || ""} onChange={(e) => setField("telefon", e.target.value)} style={inputStyle} />
        </div>

        <div>
          <label style={labelStyle}>E-mail</label>
          <input type="email" value={v.email || ""} onChange={(e) => setField("email", e.target.value)} style={inputStyle} />
        </div>

        <div>
          <label style={labelStyle}>Vztah k zesnulému</label>
          <input type="text" value={v.vztah || ""} onChange={(e) => setField("vztah", e.target.value)} style={inputStyle} />
        </div>

        <div>
          <label style={labelStyle}>Město</label>
          <input type="text" value={v.mesto || ""} onChange={(e) => setField("mesto", e.target.value)} style={inputStyle} />
        </div>

        <div>
          <label style={labelStyle}>PSČ</label>
          <input type="text" value={v.psc || ""} onChange={(e) => setField("psc", e.target.value)} style={inputStyle} />
        </div>

        <div>
          <label style={labelStyle}>Adresa</label>
          <input type="text" value={v.adresa || ""} onChange={(e) => setField("adresa", e.target.value)} style={inputStyle} />
        </div>
      </div>
    </div>
  );
}
